import React from 'react'
import { CloseButtonProps } from 'react-toastify/dist/components'
import closeIcon from '~assets/icons/times.svg'
import { Icon } from '~components/Icon'
import * as Styled from './ToastCloseButton.styles'

const ToastCloseButton: (props: CloseButtonProps) => React.ReactNode = ({ closeToast }) => (
  <Styled.Button type="button" onClick={closeToast}>
    <Icon src={closeIcon} />
  </Styled.Button>
)

export default ToastCloseButton
